'use client';
import { useGetVip } from '@/backend/vip/get-vip';
import { useUser, useVipData } from '@/store';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';

const VipProgress = () => {
	const { getVip, loading } = useGetVip();
	const vipData = useVipData();
	const user = useUser();

	useEffect(() => {
		if (user && !vipData) {
			getVip();
		}
	}, [user, vipData]);

	if (!vipData) {
		return null;
	}
	return (
		<Link
			href={'/vip/rewards'}
			className="bg-background-color border border-powder-blue rounded-[4px] px-3 hidden lg:flex items-center gap-1.5 min-h-[40px] cursor-pointer"
		>
			<Image
				width={25}
				height={25}
				src={vipData?.vip_level?.image_url}
				alt="VIP Icon"
				className="w-[25px] h-[25px] object-contain "
			/>
			<div className="p-0.5 bg-powder-blue flex items-center w-[114px] h-3 rounded-full">
				<span
					className="rounded-full duration-200 ease-out"
					style={{
						background:
							'linear-gradient(90deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.00) 100%), var(--Electric-Sky, #6680F1)',
						width: `${vipData?.vip_level?.vip_level_progress}%`,
						height: '100%',
					}}
				></span>
			</div>
			<p className=" font-bold">
				{Number(vipData?.vip_level?.vip_level_progress ?? 0).toFixed(2)}%
			</p>
		</Link>
	);
};

export default VipProgress;
